<pgh-modal-window size="md" *ngIf="modalData != null">
  <h4 modal-title><adp-label labelKey="Global_Modal_Coverage_Docs_Title"></adp-label></h4>
  <div modal-body class="mt-50 mb-50">
    <p><adp-label labelKey="Global_Modal_Coverage_Docs_Subtitle"></adp-label></p>
    <ul class="docs-links">
      <li  *ngFor="let doc of docsArr" class="docs-link">
        <a href="{{ doc.docID }}" target='_blank' [gtmClick]="doc.documentDescription" [gtmLinkURL]="doc.docID">{{
          doc.documentDescription }}</a>
      </li>
    </ul>
  </div>
  <div modal-footer class="row" >
    <div class="col-12">
      <button mat-flat-button color="accent" type="button" (click)="onClose('Yes')">
        <adp-label labelKey="Global_Button_Close"></adp-label>
      </button>
    </div>
  </div>
</pgh-modal-window>